import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';



const ParkMinSol = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "한영수 ❤️ 박민솔 결혼합니다.";
    const openDesc = "6월 7일 토요일 오후 12시 30분\n더라움 2층 마제스틱볼룸";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/224/thumb.jpg";

    const lng = 127.039775356327;
    const lat = 37.5083912736997 ;

    const placeTelNum = "02-538-3366";

    const forBus = " ·  아크로힐스 논현(구.경복아파트) 하차 : 3412, 6411\n ·  라움아트센터, 시티프라디움더강남 하차 : 141, 242, \n    361, 6411";
    const forSubway = "분당선, 9호선 선정릉역 4번출구 (도보 5분)";
    const forCar = " ·  주 소 서울시 강남구 언주로 564 (역삼동 680-1)\n                [네비게이션] 더라움, 라움아트센터\n · 주 차 예식 방문객 2시간 30분 무료";
    const forShuttleBus = "[선릉역 5번 출구 -> 라움] 예식 시작 1시간 전부터 운행\n[라움 -> 선릉역 5번 출구] 예식 종료 1시간 후까지 운행";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블루
        concept: "SUMMER",
        titleColor: "#505D89",
        pointColor: "#505D89",
        btnBgColor: "#505D89",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "우리 결혼합니다";

    const msg1 = "당신이 나의 들숨과 날숨이라면\n그 사이 찰나의 멈춤은\n당신을 향한 나의 숨멎는 사랑이어라"
    const msg2 = "<호흡, 서덕준>"
    const msg3 = "\n들숨에 사랑을, 날숨에 믿음을 새기며\n서로 아끼고 존중하며 살아가겠습니다."
    const msg4 = "귀한 걸음으로 축복해 주시면 \n오래도록 감사와 기쁨으로 간직하겠습니다.\n\n\n";


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "한영수",
            bank: "국민은행",
            accountNumber : "459202-04-112464",
            isKakao : false
        }
        // ,{
        //     role: "신랑 부",
        //     name: "권길택",
        //     bank: "신한은행",
        //     accountNumber : "110-007-235-090",
        //     isKakao : false
        // }
        // ,{
        //     role: "신랑 모",
        //     name: "박미숙",
        //     bank: "농협은행",
        //     accountNumber : "352-1282-6380-73",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박민솔",
            bank: "국민은행",
            accountNumber : "626802-04-039132",
            isKakao : false
        }
        ,{
            role: "신부 부",
            name: "박대진",
            bank: "새마을금고",
            accountNumber : "5332-10-002464-6",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "황명자",
            bank: "농협은행",
            accountNumber : "755029-52-001179",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "꿈만 같았어",
            brideAnswer: ""
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "아직 안믿겨",
            brideAnswer: ""
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "내가 잘할게",
            brideAnswer: ""
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "난 오직 너야!",
            brideAnswer: ""
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "고마워 소이",
            brideAnswer: ""
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "권유안",
            call: "010-2340-2172"
        }
        ,{
            role: "신랑 부",
            name: "권길택",
            call: "010-7979-1172"
        }
        ,{
            role: "신랑 모",
            name: "박미숙",
            call: "010-7302-1173"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "정소현",
            call: "010-9043-2745"
        }
        ,{
            role: "신부 부",
            name: "정태진",
            call: "010-3768-2286"
        }
        ,{
            role: "신부 모",
            name: "김현옥",
            call: "010-2745-2286"
        }
    ]

    const informationList =[
        {
            title : "웰컴리셉션 안내",
            content : "예식 1시간 전부터 2층 가든(야외)에 \n다과와 음료가 준비된 웰컴리셉션이 \n마련되어 있습니다.\n소중한 발걸음에 감사한 마음을 담아, \n따뜻한 시간 나누실 수 있길 바랍니다."
        }
        ,{
            title : "화환 안내",
            content : "축하화환은 정중히 사양합니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#505D89"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.groomNameEn)} brideNameEn={getRemoveSpaceName(weddingData.brideNameEn)} color={"#ffffff"} letteringFontColor={"#566FC1"} dateColor={"#505D89"} bottom={"28%"} bottom2={"18.5%"} dateBottom={"2%"} top={"2%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <Information conceptStyle={conceptStyle} informationList={informationList} />
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forShuttleBus={forShuttleBus} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkMinSol;